import React, { useEffect, useState } from "react";
import Header from "../../components/landingPage/Header";
import SideBar from "../../components/b2b/SideBar";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import {
  faArrowCircleLeft,
  faDownload,
} from "@fortawesome/fontawesome-free-solid";
import * as XLSX from "xlsx";
import axios from "axios";
import { Dialog } from "@headlessui/react";

const OpsAmmendment = () => {
  const { token } = useSelector((state) => state.auth);
  const { allOpsAmmendments, ammendmentOpsDataLoading } = useSelector(
    (state) => state.booking
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: "GET_ALL_OPS_AMMENDMENT",
      payload: {
        token: token,
      },
    });
  }, [dispatch, token]);

  return (
    <div className="fixed w-screen h-screen ">
      <Header token={token} />
      <div className="flex h-full">
        <SideBar />
        <div className="h-full w-full overflow-y-scroll scrollbar">
          {ammendmentOpsDataLoading ? (
            <>
              <div className="p-10 h-full">
                <LoadingSpinner classname="border-red-700 h-24 w-24" />
              </div>
            </>
          ) : (
            <>
              <OpsBookingTable bookings={allOpsAmmendments} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default OpsAmmendment;

export const LoadingSpinner = ({ classname }) => {
  // const spinnerSize = `h-${size} w-${size}`;
  // const spinnerColor = `border-${color}-600`;

  return (
    <div className={`flex justify-center items-center h-full`}>
      <div
        className={`border-4 ${classname} border-t-transparent rounded-full animate-spin`}
      ></div>
    </div>
  );
};

export const OpsBookingTable = ({ bookings }) => {
  const dispatch = useDispatch();
  const { token, user } = useSelector((state) => state.auth);
  const { allOpsAmmendments } = useSelector((state) => state.booking);

  const [loadingChecked, setLoadingChecked] = useState(false);
  const [loadingUnchecked, setLoadingUnchecked] = useState(false);
  const [checkedModal, setCheckedModal] = useState(false);
  const [selectedBookingId, setSelectedBookingId] = useState("");
  const [selectedAmmendemtId, setSelectedAmmendemtId] = useState("");

  const handleCheck = (ammendmentId, bookingId) => {
    setCheckedModal(true);
    setSelectedAmmendemtId(ammendmentId);
    setSelectedBookingId(bookingId);
   
  };

  const handleUncheckDownload = () => {
    setLoadingUnchecked(true);
    const data = allOpsAmmendments.map((item) => ({
      BookingID: item.bookingID,
      OldFirstName: item.paxFirstName?.oldFName || "N/A",
      NewFirstName: item.paxFirstName?.newFName || "N/A",
      OldLastName: item.paxLastName?.oldLName || "N/A",
      NewLastName: item.paxLastName?.newLName || "N/A",
      OldTravelTime: item.paxTravelTime?.oldTravelTime || "N/A",
      NewTravelTime: item.paxTravelTime?.newTravelTime || "N/A",
      OldTravelDate: item.paxTravelDate?.oldTravelDate || "N/A",
      NewTravelDate: item.paxTravelDate?.newTravelDate || "N/A",
      OldContactNumber: item.paxPhone?.oldPhone || "N/A",
      NewContactNumber: item.paxPhone?.newPhone || "N/A",
      OldFlightNumber: item.paxFlightNumber?.oldFlightNumber || "N/A",
      NewFlightNumber: item.paxFlightNumber?.newFlightNumber || "N/A",
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Unchecked Ammendments");

    XLSX.writeFile(workbook, "unchecked_ammendments.xlsx");
    setLoadingUnchecked(false);
  };

  const handleCheckDownload = async () => {
    setLoadingChecked(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/bookings/getAllCheckedOpsAmmendments`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      const checkedAmmendments = response.data?.allCheckedAmendment;

      // Prepare data for Excel export
      const data = checkedAmmendments.map((item) => ({
        BookingID: item.bookingID,
        OldFirstName: item.paxFirstName?.oldFName || "N/A",
        NewFirstName: item.paxFirstName?.newFName || "N/A",
        OldLastName: item.paxLastName?.oldLName || "N/A",
        NewLastName: item.paxLastName?.newLName || "N/A",
        OldTravelTime: item.paxTravelTime || "N/A",
        NewTravelTime: item.newTravelTime || "N/A",
        OldTravelDate: item.paxTravelDate || "N/A",
        NewTravelDate: item.newTravelDate || "N/A",
        OldContactNumber: item.paxPhone?.oldPhone || "N/A",
        NewContactNumber: item.paxPhone?.newPhone || "N/A",
        OldFlightNumber: item.paxFlightNumber?.oldFlightNumber || "N/A",
        NewFlightNumber: item.paxFlightNumber?.newFlightNumber || "N/A",
      }));

      // Convert JSON to Excel sheet and download
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Checked Ops Amendments"
      );

      XLSX.writeFile(workbook, "checked_ops_amendments.xlsx");
      setLoadingChecked(false);
    } catch (error) {
      console.error("Error fetching checked ops amendments:", error);
      setLoadingChecked(false);
    }
  };

  return (
    <div>
    {checkedModal && (
        <>
          <Dialog
            open={checkedModal}
            as="div"
            className="relative z-10 focus:outline-none"
            onClose={() => {
              setCheckedModal(false);
              setSelectedAmmendemtId("");
              setSelectedBookingId("");
            }}
          >
            <div
              className="fixed inset-0 z-10 w-screen overflow-y-auto"
              onClick={() => {
                setCheckedModal(false);
                setSelectedAmmendemtId("");
                setSelectedBookingId("");
              }}
            >
              <div className="flex min-h-full items-center justify-center p-4 bg-black/45">
                <div className="space-y-4 w-full max-w-md rounded-xl bg-white p-6 backdrop-blur-2xl duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0">
                  <div className="text-xl text-gray-500">
                    Do You Want To Mark It As Checked ?
                  </div>

                  <div className="flex justify-end space-x-3">
                    <div
                      className="cursor-pointer w-20 flex justify-center py-1 text-gray-700"
                      onClick={() => {
                        setCheckedModal(false);
                        setSelectedAmmendemtId("");
                        setSelectedBookingId("");
                      }}
                    >
                      Cancel
                    </div>
                    <div
                      className="bg-[#fb4156] rounded-full text-white cursor-pointer w-20 flex justify-center py-1"
                      onClick={() => {
                        dispatch({
                          type: "AMMENDMENT_OPS_CHECKED",
                          payload: {
                            ammendmentId: selectedAmmendemtId,
                            email: user?.userName,
                            bookingId: selectedBookingId,
                            token: token,
                          },
                        });
                      }}
                    >
                      Ok
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Dialog>
        </>
      )}
      <div className="px-4 py-2">
        <div className="flex items-center justify-between py-4">
          <div className="flex items-center space-x-2">
            <Link to="/manageBooking">
              <FontAwesomeIcon
                icon={faArrowCircleLeft}
                className="w-10 h-6 mt-1 text-gray-500"
              />
            </Link>
            <div className="text-xl text-primary font-semibold">
              Manage Booking
            </div>
          </div>
          <div className="flex space-x-2">
            <button
              onClick={handleCheckDownload}
              className={`bg-green-500 text-white px-4 py-2 rounded-full w-36 ${
                loadingChecked ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={loadingChecked} // Disable the button when loading
            >
              <FontAwesomeIcon icon={faDownload} className="mr-2" />
              {loadingChecked ? "Loading..." : "Checked"}
            </button>
            <button
              onClick={handleUncheckDownload}
              className={`bg-red-500 text-white px-4 py-2 rounded-full w-36 ${
                loadingUnchecked ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={loadingUnchecked} // Disable the button when loading
            >
              <FontAwesomeIcon icon={faDownload} className="mr-2" />
              {loadingUnchecked ? "Loading..." : "Unchecked"}
            </button>
          </div>
        </div>
        <OpsBookingInfoBox />
        <div className="overflow-x-auto relative shadow-md sm:rounded-lg max-h-[400px]">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-gray-700 uppercase bg-gray-50 text-xs sticky top-0 z-10">
              <tr>
                <th scope="col" className="py-3 px-2 xl:px-6 w-10"></th>
                <th scope="col" className="py-3 px-2 xl:px-6 w-32">
                  B-ID
                </th>
                <th scope="col" className="py-3 px-2 xl:px-6 text-red-700">
                  O.F.N
                </th>
                <th scope="col" className="py-3 px-2 xl:px-6 text-green-700">
                  N.F.N
                </th>
                <th scope="col" className="py-3 px-2 xl:px-6 text-red-700">
                  O.L.N
                </th>
                <th scope="col" className="py-3 px-2 xl:px-6 text-green-700">
                  N.L.N
                </th>
                <th scope="col" className="py-3 px-2 xl:px-6 text-red-700">
                  O.T.T
                </th>
                <th scope="col" className="py-3 px-2 xl:px-6 text-green-700">
                  N.T.T
                </th>
                <th scope="col" className="py-3 px-2 xl:px-6 text-red-700">
                  O.T.D
                </th>
                <th scope="col" className="py-3 px-2 xl:px-6 text-green-700">
                  N.T.D
                </th>
                <th scope="col" className="py-3 px-2 xl:px-6 text-red-700">
                  OCN.
                </th>
                <th scope="col" className="py-3 px-2 xl:px-6 text-green-700">
                  NCN
                </th>
                <th scope="col" className="py-3 px-2 xl:px-6 text-red-700">
                  OFL
                </th>
                <th scope="col" className="py-3 px-2 xl:px-6 text-green-700">
                  NFL
                </th>
              </tr>
            </thead>
            <tbody className="text-xs">
              {bookings?.map((booking, index) => (
                <tr
                  key={index}
                  className={`bg-white border-b ${
                    booking?.checked ? "line-through" : ""
                  } hover:bg-gray-50`}
                >
                  <td className="py-4 px-6 w-10">
                    <input
                      type="checkbox"
                      checked={booking?.checked}
                      onChange={() => {
                        booking.checked === false &&
                          handleCheck(booking?._id, booking?.bookingID);
                      }}
                      className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500"
                    />
                  </td>
                  <td className="py-4 px-2 xl:px-6 text-left">
                    {booking?.bookingID}
                  </td>
                  <td className="py-4 px-2 xl:px-6 text-red-700">
                    {booking?.paxFirstName?.oldFName ?? "N/A"}
                  </td>
                  <td className="py-4 px-2 xl:px-6 text-green-700">
                    {booking?.paxFirstName?.newFName ?? "N/A"}
                  </td>
                  <td className="py-4 px-2 xl:px-6 text-red-700">
                    {booking?.paxLastName?.oldLName ?? "N/A"}
                  </td>
                  <td className="py-4 px-2 xl:px-6 text-green-700">
                    {booking?.paxLastName?.newLName ?? "N/A"}
                  </td>
                  <td className="py-4 px-2 xl:px-6 text-red-700">
                    {booking?.paxTravelTime?.oldTravelTime ?? "N/A"}
                  </td>
                  <td className="py-4 px-2 xl:px-6 text-green-700">
                    {booking?.paxTravelTime?.newTravelTime ?? "N/A"}
                  </td>
                  <td className="py-4 px-2 xl:px-6 text-red-700">
                    {booking?.paxTravelDate?.oldTravelDate ?? "N/A"}
                  </td>
                  <td className="py-4 px-2 xl:px-6 text-green-700">
                    {booking?.paxTravelDate?.newTravelDate ?? "N/A"}
                  </td>
                  <td className="py-4 px-2 xl:px-6 text-red-700">
                    {booking?.paxPhone?.oldPhone ?? "N/A"}
                  </td>
                  <td className="py-4 px-2 xl:px-6 text-green-700">
                    {booking?.paxPhone?.newPhone ?? "N/A"}
                  </td>
                  <td className="py-4 px-2 xl:px-6 text-red-700">
                    {booking?.paxFlightNumber?.oldFlightNumber ?? "N/A"}
                  </td>
                  <td className="py-4 px-2 xl:px-6 text-green-700">
                    {booking?.paxFlightNumber?.newFlightNumber ?? "N/A"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export const OpsBookingInfoBox = () => {
  return (
    <div className="p-4 bg-gray-50 shadow-md rounded-lg max-w-full mx-auto mb-6">
      {/* <h2 className="text-lg font-semibold text-gray-700 mb-4">Table Header Full Forms</h2> */}
      <div className="grid grid-cols-5 gap-4 text-sm">
        <div className="flex flex-col items-start">
          <div className="flex items-center">
            <span className="text-gray-700 font-semibold w-16">B-ID :</span>
            <span className="text-gray-600">Booking ID</span>
          </div>
          <div className="flex items-center mt-2">
            <span className="text-red-700 font-semibold w-16">O.F.N :</span>
            <span className="text-gray-600">Old First Name</span>
          </div>
          <div className="flex items-center mt-2">
            <span className="text-green-700 font-semibold w-16">N.F.N :</span>
            <span className="text-gray-600">New First Name</span>
          </div>
        </div>
        <div className="flex flex-col items-start">
          <div className="flex items-center">
            <span className="text-red-700 font-semibold w-16">O.L.N :</span>
            <span className="text-gray-600">Old Last Name</span>
          </div>
          <div className="flex items-center mt-2">
            <span className="text-green-700 font-semibold w-16">N.L.N :</span>
            <span className="text-gray-600">New Last Name</span>
          </div>
          <div className="flex items-center mt-2">
            <span className="text-red-700 font-semibold w-16">O.T.T :</span>
            <span className="text-gray-600">Old Travel Time</span>
          </div>
        </div>
        <div className="flex flex-col items-start">
          <div className="flex items-center">
            <span className="text-green-700 font-semibold w-16">N.T.T :</span>
            <span className="text-gray-600">New Travel Time</span>
          </div>
          <div className="flex items-center mt-2">
            <span className="text-red-700 font-semibold w-16">O.T.D :</span>
            <span className="text-gray-600">Old Travel Date</span>
          </div>
          <div className="flex items-center mt-2">
            <span className="text-green-700 font-semibold w-16">N.T.D :</span>
            <span className="text-gray-600">New Travel Date</span>
          </div>
        </div>
        <div className="flex flex-col items-start">
          <div className="flex items-center">
            <span className="text-red-700 font-semibold w-16">OCN :</span>
            <span className="text-gray-600">Old Contact Number</span>
          </div>
          <div className="flex items-center mt-2">
            <span className="text-green-700 font-semibold w-16">NCN :</span>
            <span className="text-gray-600">New Contact Number</span>
          </div>
          <div className="flex items-center mt-2">
            <span className="text-red-700 font-semibold w-16">OFL :</span>
            <span className="text-gray-600">Old Flight Number</span>
          </div>
        </div>
        <div className="flex flex-col items-start">
          <div className="flex items-center">
            <span className="text-green-700 font-semibold w-16">NFL :</span>
            <span className="text-gray-600">New Flight Number</span>
          </div>
        </div>
      </div>
    </div>
  );
};
